import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { NamedLink } from '../../components';
import trialCover from '../../assets/trial-cover.png';
import css from './SubscriptionPlan.module.css';

const SubscriptionPlanTrial = () => {
  const intl = useIntl();

  return (
    <div className={css.trialSectionOuter}>
      <div className={css.trialWrapper}>
        <div className={css.trialLeft}>
          <h2 className={css.trialHeading}>
            <span
              dangerouslySetInnerHTML={{
                __html: intl.formatMessage({ id: 'SubscriptionPlan.trial.headingHtml' }),
              }}
            />
          </h2>

          <div className={css.trialSubHeadingText}>
            <p
              className={css.trialSubHeading1}
              dangerouslySetInnerHTML={{
                __html: intl.formatMessage({
                  id: 'SubscriptionPlan.trial.subHeading1Html',
                }),
              }}
            />
            <p className={css.trialSubHeading2}>
              <FormattedMessage id="SubscriptionPlan.trial.subHeading2" />
            </p>
          </div>

          <div className={css.trialButtonWrapper}>
            <NamedLink name="SearchPage" className={css.trialBookButton}>
              <FormattedMessage id="SubscriptionPlan.trial.button" />
            </NamedLink>
          </div>
        </div>

        <div className={css.trialRight}>
          <img src={trialCover} alt="Arabibi trial lesson" className={css.trialCoverImg} />
        </div>
      </div>
    </div>
  );
};

export default SubscriptionPlanTrial;
